// Clipboard payload format. Elements are copied as text so they can travel
// between browser tabs (and between v2 plans) via the system clipboard; the
// envelope marks the text as ours so pasting arbitrary text is ignored.

const MARKER = 'permapeople.planner';
export const CLIPBOARD_VERSION = 3;

// Strip the store-local id — pasted elements always get fresh ones.
export function encodeElements(elements = []) {
  const payload = {
    [MARKER]: CLIPBOARD_VERSION,
    elements: elements.map(({ id, ...el }) => el),
  };
  return JSON.stringify(payload);
}

// Returns the elements array, or null when the text isn't one of our payloads.
export function decodeElements(text) {
  if (!text || typeof text !== 'string') return null;
  let data;
  try { data = JSON.parse(text); } catch (_) { return null; }
  if (!data || typeof data !== 'object') return null;
  if (data[MARKER] !== CLIPBOARD_VERSION) return null;
  if (!Array.isArray(data.elements) || !data.elements.length) return null;
  // Only keep entries that look like elements — the text came from outside.
  const out = data.elements.filter((el) => el && typeof el === 'object'
    && typeof el.type === 'string'
    && el.data && typeof el.data === 'object');
  return out.length ? out : null;
}
